module.exports = __webpack_public_path__ + "static/media/france.db2e04a6.png";